import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API_URL || "http://localhost:5000",
  withCredentials: true,
});

// ---------------------------------------------------------------------------
// Office Time (Staff Portal)
// ---------------------------------------------------------------------------

export const getOfficeTimePortal = async () => {
  const res = await axiosInstance.get("/office-time-portal");
  return res.data;
};

export const upsertOfficeTimePortal = async (data) => {
  const res = await axiosInstance.post("/office-time-portal", data);
  return res.data;
};

// ---------------------------------------------------------------------------
// Staff Attendance (Staff Portal) — self service
// ---------------------------------------------------------------------------

export const checkIn = async () => {
  const res = await axiosInstance.post("/staff-attendance-portal/check-in");
  return res.data;
};

export const checkOut = async () => {
  const res = await axiosInstance.post("/staff-attendance-portal/check-out");
  return res.data;
};

export const getTodayAttendance = async () => {
  const res = await axiosInstance.get("/staff-attendance-portal/today");
  return res.data;
};

export const getMyAttendance = async (year, month) => {
  const res = await axiosInstance.get("/staff-attendance-portal/my", {
    params: { year, month },
  });
  return res.data;
};

// ---------------------------------------------------------------------------
// Staff Attendance (Staff Portal) — admin / principal
// ---------------------------------------------------------------------------

export const getAllAttendanceForDate = async (date) => {
  const res = await axiosInstance.get("/staff-attendance-portal/date", {
    params: { date },
  });
  return res.data;
};

export const getStaffAttendanceForMonth = async (staffId, year, month) => {
  const res = await axiosInstance.get(`/staff-attendance-portal/staff/${staffId}`, {
    params: { year, month },
  });
  return res.data;
};

export const adminMarkAttendance = async (data) => {
  const res = await axiosInstance.post("/staff-attendance-portal/mark", data);
  return res.data;
};
